export const getGroupByKeys = ({
  errorSubType,
  errorType
}) => errorSubType || errorType;